<style type="text/css">
.app-header.navbar,
.app-header.navbar .navbar-brand {
  background-color: #20a8d8;
}
.app-header.navbar .navbar-toggler {
  color: #fff;
  border: 1px solid #fff;
  border-radius: 8px;
  margin-left: 10px;
}
.dropdown-toggle::after {
  border-top: 0.3em solid #fff;
}
.nav-dropdown-items {
  width: 200px;
}
.sidebar-fixed .main,
.sidebar-fixed .app-footer {
  margin-left: 0px;
}
.nav-item a {
  color: #fff;
}
.app-header.navbar .nav-item .nav-link {
  padding-top: 15px;
}
.app-header.navbar .nav-item {
  height: 55px;
}
.language{
  height: 20px;
  margin: 10px 5px;
}
.dropdown-item.active, .dropdown-item:active {
    background-color: #afb3b5 !important;
}
/* switch */
.switch {
  position: relative;
  display: inline-block;
  width: 35px;
  height: 18px;
  left: 30px;
  top: 5px;
}

.switch input {
  display: none;
}

.global {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 20px;
  }


.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #424242;
  background-color: #e4e5e6;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider.round {
  border-radius: 10px;
}

.slider.round:before {
  border-radius: 50%;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 2px;
  bottom: 2.3px;
  background-color: white;
  border: 1px solid #000;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #ff9900;
  border: 1px solid #424242;
}

input:focus + .slider {
  background-color: #fff;
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(17px);
  -ms-transform: translateX(17px);
  transform: translateX(17px);
  border: 1px solid #808080;
}

.nav-item a {
  color: #424242;
}

.app-header.navbar .nav-item .nav-link {
  padding-top: 8px;
}

.v-sidebar-menu .vsm-item {
  border-bottom: 1px dotted #b6b7b8;
}

.parent-active-item .vsm-list .active-item .router-link-exact-active {
  color: #20a8d8 !important;
}
.test {
  position: relative;
  display: inline-block;
  width: 200px;
  height: 25px;
  left: 80px;
  top: 0px;
}
.led-light {
  margin: 0 auto;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  float: right;
}
.led-green {
  background-color: #abff00;
  box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #304701 0 -1px 9px,
    #89ff00 0 2px 12px;
}
.led-red {
  background-color: #f00;
  box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px,
    rgba(255, 0, 0, 0.5) 0 2px 12px;
}

#bar {
  display: none;
}
@media only screen and (max-width: 991px) {
  #bit00_3 {
    display: none;
  }
  #bar {
    display: block;
    position: absolute;
    left: 10px;
    height: 50px;
    width: 50px;
  }
  #bar i {
    color: #ff9900 !important;
    cursor: pointer;
    font-size: 2rem;
    height: 50px;
    width: 50px;
    line-height: 50px;
  }
  #checkbox1 {
    display: none;
  }
  .rounded {
    border-radius: 7px;
  }
}
</style>

<template>
  <header class="app-header navbar" onresize="resize">
    <b-link class="navbar-brand" to="/Dashboard"></b-link>
  <!-- <button class="navbar-toggler sidebar-toggler d-md-down-none custom_collap" @click="sidebarToggle" type="button">&#9776;</button> -->
<div align="center" id="bit00_3" @click="sidebarToggle">
  <label class="switch">
    <input type="checkbox" id="checkbox1">
    <div class="slider round">
      <span class="on"></span>
      <span class="off"></span>
    </div>
  </label>
</div>
<!--  -->
<div align="center" id="bar" @click="sidebarToggle">
<input type="checkbox" id="checkbox1" name="checkbox1">
    <label  for="checkbox1">
  <i class="fa fa-bars barcolor" aria-hidden="true"></i>
    </label>
</div>
<!--  -->
<!-- <span v-if="onLine" class ="test" style="color:#00C851;font-size: 1.1em" ><b>Internet Available</b></span>
<span v-if="!onLine" class ="test" style="color:#f22505;font-size: 1.1em" ><b>Internet Not Available</b></span> -->

<b-nav is-nav-bar>
  <div class="global" style="margin-left: 100px; margin-top: 5px">
    <div class="form-group row" v-if="showSelectClient || showSelectWarehouse">
      <div class="col-md-6" v-if="showSelectClient">
        <b-input-group>
          <select v-model="client" name="client" class="form-control rounded" style="width: 150px;" v-on:change="getWarehouseList">
            <option selected disabled value="">{{ $t('common.clientPlaceholder') }}</option>
            <option v-for="client_obj in listClientData" v-bind:value="client_obj.clientid">{{client_obj.clientname}}</option>
          </select>
        </b-input-group>
      </div>

      <div class="col-md-6" v-if="showSelectWarehouse">
        <b-input-group>
          <select v-model="warehouse" name="warehouse" class="form-control rounded" style="width: 150px;" v-on:change="warehouseSelected">
            <option selected disabled value="">{{ $t('common.warehousePlaceholder') }}</option>
            <option v-for="warehouse_obj in listWarehouseData" v-bind:value="warehouse_obj.warehouseid">{{warehouse_obj.warehousename}}</option>
          </select>
        </b-input-group>
      </div>
    </div>
  </div>

</b-nav>


    <b-nav is-nav-bar class="ml-auto" style="margin-right:1%;">

 <b-nav-item-dropdown right style="border-bottom: none; margin-right: 30px !important;" title="Change Language">
        <template slot="button-content">
            <img src="static/img/globe_icon.png" class="language" alt="Change Language">
            <label>{{locale}}</label>
          </template>
<b-dropdown-item v-for="item in localeList" @click="changeLocaleModal(item)" v-bind:key="item.value" v-bind:class="[item.value==locale ? 'active' : '']"> {{item.text}}</b-dropdown-item>  </b-nav-item-dropdown>

      <span class="led-light" onchange="onLine" :class="onLine ? 'led-green' : 'led-red'">
        <input type="hidden" v-model="onLine">
      </span>

      <b-nav-item-dropdown right style="border-bottom: none;">
        <template slot="button-content">
            <img src="static/img/avatars/default-img.png" class="img-avatar" alt="admin@bootstrapmaster.com">
            <span class="d-md-down-none" style="color: #fff !important">{{username}}</span>
          </template>
        <!-- <b-dropdown-item @click="editProfile()"><i class="fa fa-user"></i> Profile</b-dropdown-item> -->
        <b-dropdown-item @click="changepassword"><i class="fa fa-sign-out"></i> Change Password</b-dropdown-item>
        <b-dropdown-item @click="logout"><i class="fa fa-lock"></i> Logout</b-dropdown-item>
        <span v-if="user_type=='system_user'">
         <!-- <b-dropdown-item  @click="logoutAll"><i class="fa fa-lock"></i> Logout All Users</b-dropdown-item> -->
             <!-- <b-dropdown-item v-else @click="allIn"><i class="fa fa-lock"></i> Log In All Users</b-dropdown-item> -->
             </span>
      </b-nav-item-dropdown>
    </b-nav>

    <b-modal size="lm" class="confirmation" v-model="showModal" title="Change Language">
        <div class="modal-content">
         <div class="modal-headerfrm">
            <h5 class="modal-title">Change Language</h5>
            <button type="button" class="close" @click="showModal = false;" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-bodyfrm" style="padding: 2rem 1rem 0rem 1rem;">
            <div class="col-md-12">
              <b-form-fieldset>
                <label><h6>Your language will be changed to {{localeItem.text}}</h6></label>
              </b-form-fieldset>
            </div>
           </div>
          <div style="margin-left:317px;margin-bottom:10px">
            <button class="btn btn-primary"  @click="saveLocale()">
              Save
            </button>
            <button class="btn btn-danger" @click="showModal=false;">
              Cancel
            </button>
          </div>
        </div>
    </b-modal>
  </header>
</template>

<script>
  import CryptoJS from 'crypto-js';
  import axios from 'axios';
  import apiUrl from '../constants';
  import VueElementLoading from 'vue-element-loading';
  
  export default {
    name: 'header',
    components: {
      VueElementLoading
    },
    data() {
      return {
        username: '',
        usertype: '',
        user_type :'',
        logindata: [],
        navItem:[],
        onLine:false,
        allout:false,
        user_type:'',
        isLoading: false,
        localeList:[],
        localeItem:{},
        showModal: false,
        locale:'',
        listClientData: [],
        listWarehouseData: [],
        clientid: '',
        client: '',
        warehouseid: '',
        warehouse: '',
        showSelectClient : false,
        showSelectWarehouse: false,
        selectedClient:'',
        selectedwarehouse:''
      }
    },
    mounted() {
      window.addEventListener('resize', this.onResize)
      this.timeIntervalCheck()
      var userdetailEncrypt = window.localStorage.getItem('userdetail');
      var bytes  = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail =JSON.parse(plaintext);
      this.user_type = userdetail.utype;
      this.username = userdetail.fullname;
      this.loginuserid = userdetail.userid;
      this.localeList=apiUrl.locale;
      this.locale=window.localStorage.getItem('locale');
      var permissionEncrypt = window.localStorage.getItem('permissiondata');
      var bytes1  = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
      var plaintext1 = bytes1.toString(CryptoJS.enc.Utf8);
      this.navItem=JSON.parse(plaintext1);
      var value = 1;
      var checkbox1 = document.getElementById("checkbox1");
      checkbox1.checked = value;
      this.client = window.localStorage.getItem('selectedClient')

		  this.warehouse = window.localStorage.getItem('selectedWarehouse')

      switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        this.getClientList();
        this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        localStorage.setItem('selectedClient', this.client);
        this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.warehouse = this.warehouseid;
        localStorage.setItem('selectedWarehouse', this.warehouse);
        this.showSelectClient = true;
        this.getClientList();

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;
      default:
        this.$alertify.error(this.$t('common.unauthorisedError'));
        break
    }

      document.getElementById("checkbox1").addEventListener("change", function(element){
        if(checkbox1.checked==false){
          $(".v-sidebar-menu").css("left","-270px");
          $(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left","0px");
        }else if(checkbox1.checked==true){
          $(".v-sidebar-menu").css("left","0px");
          $(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left","270px");
        }

      });

       if(document.body.offsetWidth>768)
        {
          //console.log("heretoo"+checkbox1.checked)
          if(checkbox1.checked==false ){
                  //console.log("here")
              checkbox1.checked=true
                $(".v-sidebar-menu").css("left","0px");
                $(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left","270px");
              }
        }
        if(document.body.offsetWidth<768)
        {

            if( checkbox1.checked==true ){
          checkbox1.checked=false
          $(".v-sidebar-menu").css("left","-270px");
            $(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left","0px");
          }
        }


      },
      beforeDestroy() {
  window.removeEventListener('resize', this.onResize)
  if (localStorage.getItem("selectedClient") == undefined)
      {
        $alertify("Please select Client")
      }
      if (localStorage.getItem("selectedWarehouse") == undefined)
      {
        $alertify("Please select Warehouse")
      }
},
      watch: {
        onLine: function() {
          if(this.onLine)
          {
          //  this.$alertify.success("You are Online");
          }
          else {
            this.$alertify.error("You are Offline");
          }
        }
      },
      methods: {

      getClientList() {
      if (window.localStorage.getItem("clientList") !== null) {
        var clientListEncrypt = window.localStorage.getItem('clientList');
        var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
        var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
        this.listClientData = JSON.parse(plaintextclient);
      } else {
        var userToken = window.localStorage.getItem('userToken');
        var myStr = userToken.replace(/"/g, '');
        if (this.warehouseid)
          this.input = ({
            warehouseid: this.warehouseid,
          });
        else {
          this.input = {};
        }

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
          .then(result => {
            this.listClientData = result.data.data;
            var clientEncrypt = CryptoJS.AES.encrypt(JSON.stringify(this.listClientData), "Key");
					window.localStorage.setItem('clientList', clientEncrypt);
          }, error => {
            console.error(error);
          });
      }
    },

    getWarehouseList() {
      if (window.localStorage.getItem("warehouseList") !== null) {
        var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
        var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
        var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
        this.listWarehouseData = JSON.parse(plaintextwarehouse);
      } else {
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = ({
          clientid: this.client,
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then(result => {
            this.listWarehouseData = result.data.data;

            this.clientSelected()

          }, error => {
            console.error(error)
          })
      }
    },
    clientSelected() {
     this.selectedClient = localStorage.getItem('selectedClient');
      if ((!this.selectedClient || this.selectedClient != this.client) && this.client!=undefined) {
        localStorage.setItem('selectedClient', this.client);
        this.$router.go()
      }
    },
    warehouseSelected() {
        //localStorage.setItem('selectedWarehouse', this.warehouse)
        this.selectedwarehouse=localStorage.getItem('selectedWarehouse');
        console.log(this.selectedwarehouse ,"==warehouse===", this.warehouse)
        if( (this.selectedwarehouse != this.warehouse) && Number(this.warehouse)>0 && Number(this.selectedwarehouse)>0  ){
          localStorage.setItem('selectedWarehouse', this.warehouse)
         // alert("1")
          this.$router.go()
        }
        if(!this.selectedwarehouse || this.selectedwarehouse != this.warehouse ){
          localStorage.setItem('selectedWarehouse', this.warehouse)
          //alert("2")
          // this.$router.go()
        }
        this.$root.$emit('localStorageChanged', this.warehouse);
    },

      onResize(event) {

       if(document.body.offsetWidth>768)
        {     let checkbox1= document.getElementById("checkbox1")
          if(checkbox1.checked==false ){
                  console.log("here")
              checkbox1.checked=true
                $(".v-sidebar-menu").css("left","0px");
                $(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left","270px");
              }
        }
        if(document.body.offsetWidth<768)
        {
            let checkbox1= document.getElementById("checkbox1")
            if( checkbox1.checked==true ){
          checkbox1.checked=false
          $(".v-sidebar-menu").css("left","-270px");
            $(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left","0px");
          }
        }
  },
      timeIntervalCheck() {
        setInterval(() => {
          this.checkOnline();
        }, 1000);
      },
      checkOnline() {
        this.onLine = navigator.onLine
      },
        sidebarToggle() {
      },
      someHandler(){
        alert("1")
        if(onLine)
          this.$alertify.success("You are Online");
        else {
          this.$alertify.error("You are Offline");
        }
      },
      logout(e) {
        e.preventDefault()

        var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
        const params = new URLSearchParams()
        params.append('client_id', 'xbwms-ui')
        params.append('refresh_token', window.localStorage.getItem('refreshToken'))

        let url = apiUrl.kavachURL+'/realms/xpressbees/protocol/openid-connect/logout';
        let apiconfig = {
              'Content-Type':'application/x-www-form-urlencoded',
							'Authorization': 'Bearer ' + myStr
						}
        axios.post(url, params, apiconfig);

        localStorage.removeItem('permissiondata')
        localStorage.removeItem('userdetail')
        localStorage.removeItem('userToken')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('clientList')
        localStorage.removeItem('warehouseList')
        localStorage.removeItem('innerpermissiondata')
        localStorage.removeItem('hasReloaded')
        localStorage.removeItem('slaconfig')
        localStorage.removeItem('locale')
        localStorage.setItem("keyclockloginpage", false);
        localStorage.setItem('keycloakInitialized',false)
        localStorage.setItem('islogout',true)
        this.$router.push('/login')
        
      },
       changepassword() {
        this.$router.push('/changepassword')
      },
      changeLocaleModal(item){
        this.showModal= true;
        this.localeItem = item;
      },
		  saveLocale() {
			if (!this.localeItem.value) {
				this.$alertify.error("Please select language")
				return false;
			}

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				userid: this.loginuserid,
				locale: this.localeItem.value
			})
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'changelanguage',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data[0].data.code == 0) {
						this.isLoading = false
            this.showModal = false
						this.$alertify.success(response.data[0].data.msg);
						localStorage.setItem('locale',this.localeItem.value)
            if(response.data[1].permissions.length>0){
							var permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[1].permissions), "Key");
							window.localStorage.setItem('permissiondata', permissionEncrypt);
              this.$router.go()
            }else{
              this.$router.push('/login');
            }
					} else if (response.data[0].data.code == -1) {
						this.isLoading = false
            this.showModal = false
						this.$alertify.error(response.data[0].data.msg)
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
      editProfile() {
        if (this.usertype == 'Merchant')
          this.$router.push('/merchantProfile');
        else if (this.usertype == 'Client')
          this.$router.push('/companyProfile');
        else
          this.$router.push('/');
      },
      logoutAll(){
        this.allout=true
        var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
        axios({
						method: 'POST',
						'url': apiUrl.api_url + 'logoutAllUser',
						'data': {flag:true},
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
					  this.$alertify.success("all users logout successfully");
					}, error => {
						console.error(error)
					})


      },
       allIn(){
        this.allout=false
          var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
          axios({
						method: 'POST',
						'url': apiUrl.api_url + 'logoutAllUser',
						'data': {flag:false},
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
					  this.$alertify.success("all users logIn successfully");
					}, error => {
						console.error(error)
					})

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue?1435639e